// tslint:disable:max-line-length

import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/authentication/auth-guard';
import { Perfis } from '../../models/perfis';

import { GerenciarProvaPraticaComponent } from './gerenciar-prova-pratica/gerenciar-prova-pratica.component';
import { CadastrarResultadoProvaPraticaComponent } from './cadastrar-resultado-prova-pratica/cadastrar-resultado-prova-pratica.component';

const ProvaPraticaRoutes: Routes = [
    {
        path: 'prova-pratica',
        canActivate: [ AuthGuard ],
        data: { roles: [
            Perfis.AdministradorSistema, Perfis.GestorUnidadeOperacional, Perfis.AdministrativoUnidadeOperacional
        ]},
        children: [
            { path: 'gerenciar/:idCandidato', component: GerenciarProvaPraticaComponent },
            { path: 'cadastrar-resultado/:idCandidato', component: CadastrarResultadoProvaPraticaComponent }
        ]
    }
];

export const ProvaPraticaRouting = RouterModule.forChild(ProvaPraticaRoutes);



// WEBPACK FOOTER //
// ./src/app/components/provaPratica/prova-pratica.routing.ts